import { Type } from "class-transformer";
import { EnaioObjectTypeId } from "./EnaioObjectTypeId";

export class ExportStorageHeader {
    version = 0;
    @Type(() => EnaioObjectTypeId)
    objectTypes: EnaioObjectTypeId[];
}
